import { FooterLink } from './types';
import localPrivacyFooterLinks from './footer-privacy-links.json';
export const defaultPrivacyFooterLinks: FooterLink[] = localPrivacyFooterLinks as FooterLink[];
